"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpackColorShader = void 0;
const rc_js_util_1 = require("rc-js-util");
const gl_shader_1 = require("../gl-shader");
/**
 * @public
 * Takes a float32 which is used to store a packed int24 storing RGB.
 */
exports.unpackColorShader = new gl_shader_1.GlShader(
// @formatter:off
// language=GLSL
`
#ifndef FLOAT_COLOR_PACKER

#define FLOAT_COLOR_PACKER 1

/* === color unpacker (float) === */
const highp int ERgbaShift_R = ${rc_js_util_1.ERgbaShift.R};
const highp int ERgbaShift_G = ${rc_js_util_1.ERgbaShift.G};
const highp int ERgbaShift_B = ${rc_js_util_1.ERgbaShift.B};

const highp int ERgbaMasks_R = 0xFF << ERgbaShift_R;
const highp int ERgbaMasks_G = 0xFF << ERgbaShift_G;
const highp int ERgbaMasks_B = 0xFF << ERgbaShift_B;

mediump vec4 unpackColor(highp float packedColor)
{
    highp int tmp = int(packedColor);
    const highp float sf = 1./255.;

    return vec4(
        float(((tmp & ERgbaMasks_R) >> ERgbaShift_R) & 0xFF) * sf,
        float(((tmp & ERgbaMasks_G) >> ERgbaShift_G) & 0xFF) * sf,
        float(((tmp & ERgbaMasks_B) >> ERgbaShift_B) & 0xFF) * sf,
        1.
    );
}

#endif
`, 
// @formatter:on
300);
//# sourceMappingURL=unpack-color-shader.js.map